var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import Entrada from './entrada';

var BotoneraIndice = function (_React$Component) {
  _inherits(BotoneraIndice, _React$Component);

  function BotoneraIndice() {
    _classCallCheck(this, BotoneraIndice);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  BotoneraIndice.prototype.renderEntrada = function renderEntrada(entrada, numGrupo, index) {
    var _props = this.props,
        libroId = _props.libroId,
        onEntrada = _props.onEntrada;

    var propsEntrada = _extends({}, entrada);

    if (entrada.indice) {
      propsEntrada.activa = entrada.indice === libroId;
    }

    propsEntrada.onClick = function () {
      return onEntrada(entrada);
    };

    return React.createElement(Entrada, _extends({
      key: 'entrada-' + numGrupo + '-' + index
    }, propsEntrada));
  };

  BotoneraIndice.prototype.renderGrupo = function renderGrupo(grupo, numGrupo) {
    var _this2 = this;

    return React.createElement('div', {
      key: 'botones-libro-' + numGrupo,
      className: 'botonesLibros'
    }, grupo.map(function (entrada, index) {
      return _this2.renderEntrada(entrada, numGrupo, index);
    }));
  };

  BotoneraIndice.prototype.renderGrupos = function renderGrupos(grupos) {
    var _this3 = this;

    if (!grupos) {
      return;
    }

    return grupos.map(function (entradaOGrupoDeEntradas, numGrupo) {
      if (Array.isArray(entradaOGrupoDeEntradas)) {
        return _this3.renderGrupo(entradaOGrupoDeEntradas, numGrupo + 1);
      } else {
        return _this3.renderEntrada(entradaOGrupoDeEntradas, 1, numGrupo + 1);
      }
    });
  };

  BotoneraIndice.prototype.render = function render() {
    var botoneraIndice = this.props.botoneraIndice;
    var izquierda = botoneraIndice.izquierda,
        centro = botoneraIndice.centro,
        derecha = botoneraIndice.derecha;
    return React.createElement('div', {
      className: 'botoneraIndice'
    }, React.createElement('div', {
      className: 'alineadoIzquierda'
    }, izquierda && this.renderGrupos(izquierda)), this.renderGrupos(centro), React.createElement('div', {
      className: 'alineadoDerecha'
    }, this.renderGrupos(derecha)));
  };

  return BotoneraIndice;
}(React.Component);

BotoneraIndice.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string.isRequired,
  botoneraIndice: t.shape({
    izquierda: t.array,
    centro: t.array,
    derecha: t.array
  }).isRequired,
  onEntrada: t.func.isRequired
} : {};
export default BotoneraIndice;